export default function () {
  return {
    isMaintenanced: false,
    pushSocketInstance: null // push용 socket instance
  }
}
